import React from 'react';
import './ConfirmationDialog.scss';
import './UnsavedChangesDialog.scss';
import { confirmButton, cancelButton } from '../Buttons';

// "Leave without saving?" Save saves and then leaves, discard drops the changes
// and leaves, and the X (or Escape) stays on the page with the changes kept.
type Props = {
  open: boolean;
  isSaving?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onClose: () => void;
};

const UnsavedChangesDialog: React.FC<Props> = ({ open, isSaving = false, onSave, onDiscard, onClose }) => {
  if (!open) return null;

  return (
    <div
      className="confirmation-dialog-overlay"
      onKeyDown={(event) => { if (event.key === 'Escape' && !isSaving) onClose(); }}
    >
      <div className="confirmation-dialog unsaved-changes-dialog" role="dialog" aria-modal="true" aria-labelledby="unsaved-changes-title" dir="rtl">
        <button
          type="button"
          className="unsaved-changes-close"
          aria-label="סגירה והישארות בדף"
          onClick={onClose}
          disabled={isSaving}
          autoFocus
        >
          ×
        </button>
        <h2 id="unsaved-changes-title" className="confirmation-dialog-title">יש שינויים שלא נשמרו</h2>
        <div className="confirmation-dialog-message">האם לצאת בלי לשמור? השינויים שלא נשמרו יאבדו.</div>
        <div className="confirmation-dialog-actions">
          <button type="button" style={confirmButton} onClick={onSave} disabled={isSaving}>
            {isSaving ? 'שומר…' : 'שמירה ויציאה'}
          </button>
          <button type="button" style={cancelButton} onClick={onDiscard} disabled={isSaving}>
            יציאה בלי לשמור
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesDialog;
